import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantResidenceRelationshipPage = {
  footer: {
    root: 'coapplicant-residence-relationship-page.footer.root',
  },
  form: {
    h1: 'coapplicant-residence-relationship-page.form.h1',
    h2: 'coapplicant-residence-relationship-page.form.h2',
    radioGroupRoot:
      'coapplicant-residence-relationship-page.form.radio-group-root',
    radioOption1: 'coapplicant-residence-relationship-page.form.radio-option1',
    radioOption2: 'coapplicant-residence-relationship-page.form.radio-option2',
    root: 'coapplicant-residence-relationship-page.form.root',
    submitButton: 'coapplicant-residence-relationship-page.form.submit-button',
  },
  header: {
    drawerButton:
      'coapplicant-residence-relationship-page.header.drawer-button',
    previousStepButton:
      'coapplicant-residence-relationship-page.header.previous-step-button',
    root: 'coapplicant-residence-relationship-page.header.root',
  },
  progress: {
    root: 'coapplicant-residence-relationship-page.progress.root',
  },
} as const satisfies PageLocatorMap;
